import React from 'react';
import Logo from '../Logo';
import SeletorDeIdioma from '../SeletorDeIdioma';
import { reabrirAvisoDeCookies } from '../AvisoDeCookies';
import { EMAIL_DE_CONTATO } from '../../config/contato';
import { Link, caminhoNo, useIdioma } from '../../i18n';
import '../../styles/Fecho.css';

/* Seções da home. Com a barra na frente, as âncoras servem também ao Blog e ao
   Post, que fecham com este mesmo rodapé; na home só o fragmento muda. */
const SECOES = [
  { href: '/#como', chave: 'inicio.fecho.comoFunciona' },
  { href: '/#features', chave: 'inicio.fecho.cincoAreas' },
  { href: '/#saidas', chave: 'inicio.fecho.oQueSai' },
  { href: '/#alem', chave: 'inicio.fecho.alem' },
  { href: '/#pricing', chave: 'site.precos' },
  { href: '/#perguntas', chave: 'inicio.fecho.perguntas' }
];

const CREDITO = 'https://commons.wikimedia.org/wiki/File:Mountain_Lion_Roaming_at_Night_(11425790463).jpg';

/**
 * O fechamento da página nova: a fotografia de um puma registrada por uma
 * armadilha fotográfica de um lado, o menu do outro. O Footer compartilhado
 * continua servindo o Blog, os Planos e as páginas jurídicas.
 *
 * A foto vem de `public/` por URL, e não por `import`: o pré-render embute em
 * base64 as imagens importadas, e ela iria inteira para dentro do HTML.
 */
const Fecho = () => {
  const { t, idioma } = useIdioma();

  return (
    <footer className="nh fecho">
      <figure className="fecho-foto">
        <img
          src="/marca/puma-armadilha-fotografica.jpg"
          width="1280"
          height="867"
          loading="lazy"
          alt={t('inicio.fecho.fotoAlt')}
        />
        <figcaption>{t('inicio.fecho.fotoLegenda')}</figcaption>
      </figure>

      <div className="fecho-menu">
        <Link to="/" className="fecho-marca" aria-label="Silent Puma">
          <Logo size={26} />
        </Link>
        <nav className="fecho-secoes" aria-label={t('inicio.fecho.navegacao')}>
          {SECOES.map((s) => (
            <a key={s.href} href={caminhoNo(idioma, s.href)}>{t(s.chave)}</a>
          ))}
          <Link to="/blog">{t('site.blog')}</Link>
        </nav>
        <div className="fecho-blocos">
          <p>
            <b>{t('site.contato')}</b>
            <a href={`mailto:${EMAIL_DE_CONTATO}`}>{EMAIL_DE_CONTATO}</a>
            <br />
            {t('inicio.fecho.chat')}
          </p>
          <p>
            <b>{t('inicio.fecho.conta')}</b>
            <Link to="/login">{t('site.entrar')}</Link>
            <br />
            <Link to="/signup">{t('inicio.fecho.criarConta')}</Link>
          </p>
          <div>
            <b>{t('site.idioma')}</b>
            <SeletorDeIdioma />
          </div>
        </div>
        <p className="fecho-legal">
          <span>{t('site.direitos', { ano: new Date().getFullYear() })}</span>
          <Link to="/privacy-policy">{t('site.privacidade')}</Link>
          <Link to="/terms-of-service">{t('site.termos')}</Link>
          <button type="button" onClick={reabrirAvisoDeCookies}>
            {t('cookies.titulo')}
          </button>
          <span>
            {t('inicio.fecho.fotoCredito')} <a href={CREDITO}>Wikimedia Commons</a>
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Fecho;
